import { media } from '@anm/styles/helpers';
import Loadable from 'react-loadable';
import styled from 'styled-components';

const Slider = Loadable({
  loader: () => import('../TemplateVideoSlider/Slider'),
  loading: () => null
});

const TemplateListWithSliderWrapperTabletStyles = media.tablet`
  display: none;
`;

export const sliderItemHeight = 100;

export const SliderItem = styled.div<{ isActive: boolean }>`
  height: ${sliderItemHeight}px;
  margin: 0 10px;
  cursor: pointer;
  outline: none;
  img {
    height: 100%;
    padding: 3px;
    transition: 0.3s;
    border: 3px solid transparent;
    border-radius: 5px;
    border-color: ${({ isActive }) => (isActive ? 'var(--blue_100)' : 'transparent')};
    &:hover {
      border-color: var(--blue_100);
    }
  }
`;
const TemplateListWithSliderWrapper = styled(Slider)`
  width: calc(92vw - 500px);
  margin-right: -50px;
  ${TemplateListWithSliderWrapperTabletStyles};
`;

export default TemplateListWithSliderWrapper;
